import '../../../node_modules/flickity/css/flickity.css';
import '../../styles/flickity-page-dots.scss';

import '../../styles/collection.scss';
import '../../styles/collection.featured.scss';

import '../snippets/product-grid-item';

var Ajaxinate = require("exports-loader?Ajaxinate!./../utils/ajaxinate.js");

import io from '../utils/intersection-observer';

document.addEventListener("DOMContentLoaded", () => {
  var endlessScroll = new Ajaxinate({
    callback: () => {
      document.querySelectorAll('.AjaxinateLoop img[defer]:not([deferred])').forEach(el => {
        if(Modernizr.touchevents && el.dataset.isHoverimage) {
          return;
        } else {
          io.observe(el);
        }
      });
    }
  });
});
